import React from 'react';
import PropTypes from 'prop-types';
import { ArrowLeft } from 'react-feather';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import { routes } from 'constants/config';

const BackToPath = ({ pathId, pathName, isPreviewing }) => {
  const route = isPreviewing
    ? routes.PREVIEW_LEARNER_PATH(pathId)
    : routes.LEARNER_PATH(pathId);

  return (
    <a className="LessonHeaderBackToPath u-linkBtn d-f ai-c wb-bw" href={route}>
      <ArrowLeft className="f-sh-0 mr-8" />
      <span className="LessonHeader-pathName wb-ba ws-pr">
        <Text variant={TEXT_VARIANTS.BODY_LINK}>{pathName}</Text>
      </span>
      <span className="LessonHeader-backLink">
        <Text variant={TEXT_VARIANTS.BODY_LINK}>{t('common.back')}</Text>
      </span>
    </a>
  );
};

BackToPath.propTypes = {
  pathId: PropTypes.string.isRequired,
  pathName: PropTypes.string.isRequired,
  isPreviewing: PropTypes.bool,
};

BackToPath.defaultProps = {
  isPreviewing: false,
};

export default props => <BackToPath {...props} />;
